import { Injectable } from '@angular/core';
import {
  BaseService,
  HttpClient,
  HttpHeaders,
  HttpParams,
} from './base.service';
import { IItemCategory } from '../shared/api';
import { AccountService } from './account.service';

@Injectable()
export class ItemCategoryService extends BaseService<IItemCategory> {
  constructor(accountService: AccountService, http: HttpClient) {
    super(accountService, http, 'itemCategory');
  }
}

export { IItemCategory } from '../shared/api';
